var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 20 20",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,5.9c0-0.6-0.5-1-1-1s-1,0.5-1,1s0.5,1,1,1S14.9,6.4,14.9,5.9z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,6.8L18.8,6.8c-0.4-1-1.1-2.4-2.2-3.5c-1.1-1.1-2.5-1.8-3.5-2.2C12.8,1,12.5,1,12.2,1c-0.7,0-1.4,0.3-1.9,0.8L7.4,4.6c-0.8,0.8-1,2-0.6,3c0.1,0.3,0.3,0.6,0.5,1l0,0.1l-6.2,6.2C1,15,1,15.1,1,15.3v3.1C1,18.8,1.2,19,1.6,19h3.1c0.3,0,0.6-0.3,0.6-0.6V17h1.4c0.3,0,0.6-0.3,0.6-0.6V15h1.4c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-2c-0.3,0-0.6,0.3-0.6,0.6v1.4H4.7c-0.3,0-0.6,0.3-0.6,0.6v1.4h-2v-2.3l6.4-6.4C8.7,9,8.8,8.7,8.6,8.4C8.4,8,8.1,7.6,7.9,7.1C7.7,6.5,7.8,5.9,8.3,5.4l2.8-2.8c0.4-0.4,1.1-0.6,1.7-0.4c0.8,0.3,2.1,0.9,3.1,1.9c1,1,1.6,2.2,2,3.1c0.2,0.6,0.1,1.2-0.3,1.7l-2.8,2.8c-0.4,0.4-1.1,0.6-1.7,0.3c-0.5-0.2-0.9-0.4-1.3-0.7c-0.3-0.2-0.6-0.1-0.8,0.2c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.3,0.3,0.4c0.5,0.3,1,0.5,1.5,0.8c1,0.4,2.2,0.2,3-0.6l2.8-2.8C19,9,19.2,7.8,18.8,6.8z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.0a1cdf691134a46521b2ec736146d1c7.svg";
export { ForwardRef as ReactComponent };